import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=84a82942&scoped=true&"
import script from "./EditDialog.vue?vue&type=script&lang=js&"
export * from "./EditDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=84a82942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a82942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VContainer,
  VDialog,
  VFlex,
  VForm,
  VLayout,
  VTextField,
})
